import React from 'react'
import PropTypes from 'prop-types'
import {Card,CardContent,CardActions,CardMedia,CardHeader,IconButton,Typography,withStyles,Zoom,Divider,Chip} from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AssignmentIcon from '@material-ui/icons/Assignment'
import {Muted} from "../";
import {primaryColor} from "../../assets/jss/material-dashboard-react"
import Moment from 'react-moment';

export const SurveyTile = ({...props})=> {

    const {title,createdAt,status,classes,onClick} = props;

    return(
        <Zoom in={true}>
            <Card  className={classes.card} onClick={onClick}>
            <CardMedia
          className={classes.media}
          image="/static/images/cards/paella.jpg"
          

        >
        <AssignmentIcon style={styles.surveyIcon}/>
        </CardMedia>
        <CardHeader className={classes.head}
 
            action={
              <IconButton>
                <MoreVertIcon />
              </IconButton>
            }
            title={ <div className={classes.surveyText}>
                        <p style={styles.titleText}>
                            {title?title:"Untitled Campaign"}
                        </p>
                        
                    </div>}
            subheader={<div className={classes.subTitleText}>
                             <div style={{paddingTop:18}}>Created: <Moment format={"DD MMMM YY"} unix>{createdAt?createdAt.seconds:Date.now}</Moment></div>
                           <div style={{paddingTop:8,paddingBottom:10}} className={classes.surveyText}>
                           Status: {status?<Chip label="Active" style={{backgroundColor:"#4CAF50",color:"#fff"}}></Chip>:<Chip label="Inactive" style={{backgroundColor:"#FF9900",color:"#fff"}}></Chip>}
                           </div>
                        </div>}
          />

            </Card>
        </Zoom>
    )
}

const styles={
    card:{
        width:230,
        height:280,
        margin:20,
        cursor: "pointer"
    },
    cardContent:{
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        paddingBottom:0,

    },
    media: {
        backgroundColor: "#f1f1f1",
        display:"flex",
        justifyContent:"center",
        paddingBottom:'20%',
        height: 0,
        paddingTop: '54.25%', 
        
    },
    surveyIcon:{
      fontSize:100,
        color:primaryColor,
        marginTop:"-40%"
    },
    cardActions:{
        display:"flex",
    },
    titleText:{
        width:165,
        fontSize:14,
        fontWeight:"bold",
        overflow:"hidden",
        whiteSpace: "nowrap",
        lineHeight: 1,
        marginTop:"-2%",
    },
    subTitleText:{
        width:168,
        overflow:"hidden",
        whiteSpace: "nowrap",
        marginTop: "-15%",

    },
    surveyText:{
        flexDirection:"column"
    },
    nextLine:{
        flexDirection:"column"
    },
    button:{

    },
    head: {
        paddingLeft:"20px !important",
        paddingRight: "20px !important"
    }

}

export default withStyles(styles)(SurveyTile)


// WEBPACK FOOTER //
// ./src/components/SurveyTile/SurveyTile.jsx